import TAheader from "../../images/header.png";
import TAfooter from "../../images/footer.png";
// import headerLandscape from "../../images/headerLandscape.png";
// import footerLandscape from "../../images/footerLandscape.png";
import { getImageDimensions } from "../getImageDimensions";
import imageExists from "../imageExists";

export async function addHeaderAndFooter(doc, pageOffset, uid) {
  var pageInfo = doc.internal.getCurrentPageInfo();
  const isPortrait =
    pageInfo.pageContext.mediaBox.topRightX <
    pageInfo.pageContext.mediaBox.topRightY;

  //Get page height minus some
  const pageHeight = isPortrait ? 11 : 8.5;
  const pageWidth = isPortrait ? 8.5 : 11;
  // console.log("Page Height:", pageHeight);
  //Header logo
  const userHeader = await imageExists(
    `https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2F${uid}%2FheaderImage.jpg?alt=media`
  );
  const userFooter = await imageExists(
    `https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2F${uid}%2FfooterImage.jpg?alt=media`
  );
  const headerImage = userHeader ? userHeader : TAheader;
  const footerImage = userFooter ? userFooter : TAfooter;
  const TAheaderDem = userHeader
    ? { width: userHeader.width, height: userHeader.height }
    : await getImageDimensions(headerImage);

  const scaledImageWidth = pageWidth - 1;
  const headerXdiffPerc = scaledImageWidth / TAheaderDem.width;
  const scaledHeight = TAheaderDem.height * headerXdiffPerc;
  // console.log(
  //   `Scaled Height: ${scaledHeight} Scaled Width: ${scaledImageWidth}`
  // );
  doc.addImage(
    headerImage,
    "PNG",
    0.5,
    0.25,
    scaledImageWidth,
    scaledHeight,
    undefined,
    "FAST",
  );

  //Footer logo
  const TAfooterDem = userFooter
    ? { width: userFooter.width, height: userFooter.height }
    : await getImageDimensions(footerImage);
  const xdiffPerc = scaledImageWidth / TAfooterDem.width;
  const scaledHeightx = TAfooterDem.height * xdiffPerc;
  // console.log(
  //   `Scaled Height: ${scaledHeightx} Scaled Width: ${scaledImageWidth}`
  // );
  doc.addImage(
    footerImage,
    "PNG",
    0.5,
    pageHeight - 0.6, //add gap from content
    scaledImageWidth,
    scaledHeightx,
    undefined,
    "FAST",
  );

  doc.setFontSize(8);
  doc.text(
    pageWidth - 0.8,
    pageHeight - 0.6,
    "-" + (pageInfo.pageNumber + pageOffset) + "-",
  ); //print number bottom right
}
